<template>
    <div>
        <h1 class="first-header heading-large"><i class="fas fa-handshake mr-2"></i>Today's Negotiations</h1>
        <div class="card conversations--wrapper overflow-auto bg-olf-light-greyish-blue">
            <div v-if="negotiations.length < 1" class="text-center m-3">
                No negotiations placed
            </div>
            <div v-else>
                <a 
                    href="#" 
                    class="conversations--action d-flex py-2 justify-content-between border-bottom text-decoration-none" 
                    data-toggle="modal" data-target="#myNegotiation"
                    :class="{active: negotiationSelected && negotiationSelected._id == negotiation._id}"
                    v-for="(negotiation,key) in negotiations" :key="key" @click="showNegotiationDetails(negotiation, key)"
                >
                    <div class="d-flex justify-content-start">
                        <span v-if="negotiation.counterOffers" class="conversations--image m-3 position-relative" :class="{'all-offline': !isAnySellerOnline[key]}">
                            {{negotiation.counterOffers.length}}
                            <i class="fas notification" v-if="notificationList.find(n => n.type_id === 'NEGOTIATION' && n.group_id === negotiation._id && n.viewed == null)"></i>
                        </span>
                        
                        <div 
                            class="d-flex flex-column text-tertiary justify-content-center"
                            :class="{'align-items-start' : $breakpoint.smAndDown && !$breakpoint.xsOnly}"
                        >
                            <h5>{{negotiation.fuel_id | fueltype}}</h5>
                            <span v-if="getFuelsType.find(fuel => fuel._id == negotiation.fuel_id).type == 'SPOT'">
                                <span v-if="negotiation.terminal">
                                    {{negotiation.terminal.name}}
                                </span>
                                <span v-else>N/A</span>
                            </span>
                            <span v-else>Network</span>
                            <div class="d-flex justify-content-between flex-row">
                                <strong class="mr-2">
                                    <!-- Check whether calculated live price exceeds the negotiation's max price -->
                                    {{negotiation.type_id == 'FIXED' || negotiation.status_id == 'COMPLETED' ?
                                        negotiation.price : negotiation.livePrice | priceformat}} ppl
                                </strong>
                                <strong>{{negotiation.quantity | volumeformat}} l.</strong>
                            </div>
                        </div>
                    </div>
                    <span 
                        class="negotiation-status d-flex justify-content-center mr-3 text-tertiary flex-row"
                    >
                        <span v-if="negotiation.status_id == 'COMPLETED'" class="static accepted">Accepted</span>
                        <span v-else-if="negotiation.status_id == 'WITHDRAWN'" class="static withdrawn">Withdrawn</span>
                        <span v-else>
                            <span 
                                class="d-flex align-items-center flex-column"
                                v-if="negotiationsStatuses[key] == 'ACTIVE'">
                                {{negotiationsTimeRemaining[key] | countdownshortformat}}
                                <radial-progress-bar class="countdown-progress" :diameter="35" 
                                    :totalSteps="(new Date(negotiation.expires) - new Date(negotiation.created))/1000" 
                                    :completedSteps="negotiationsTimeRemaining[key]" />
                            </span>
                            <span v-else-if="negotiationsStatuses[key] == 'INACTIVE'" class="static expired">Expired</span>
                            <span v-else>Loading</span>
                        </span>
                    </span>
                </a>    
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations,mapGetters } from 'vuex';
import breakpoint from '@/mixins/index';

export default {
    mixins: [breakpoint],
    data:function(){
        return {
            isAnySellerOnline: [],
            countdownFunction: '',
            negotiationsTimeRemaining: [],
            negotiationsStatuses: []
        }
    },
    created: function(){
        const payload = {
            status: 'All',
            accountId: this.userLoggedIn.id
        }
        this.getNegotiations(payload)
    },
    computed: {
        ...mapState('negotiation',['negotiationSelected']),
        ...mapState('login',['userLoggedIn']),
        ...mapState('notifications', ['notificationList']),
        ...mapGetters('fuelsType', ['getFuelsType']),
        ...mapGetters('negotiation',['getNegotiationListChanges']),
        ...mapGetters('terminals', ['getTerminalChanges']),
        negotiations: {
            get: function(){
                let allNegotiations = []

                if (this.getNegotiationListChanges){
                    allNegotiations = this.getNegotiationListChanges
                }

                return allNegotiations
            }
        },
        performCountdown: function(){
            if (this.negotiations){
                if (this.countdownFunction){
                    clearInterval(this.countdownFunction)
                }
                
                this.countdownFunction = setInterval(() => {
                    this.negotiations.forEach((negotiation, index) => {
                        this.negotiationsTimeRemaining.splice(index, 1, (new Date(negotiation.expires) - new Date())/1000)
                        
                        if (negotiation.status_id == 'ACTIVE' && this.negotiationsTimeRemaining[index] > 0){
                            this.negotiationsStatuses.splice(index, 1, 'ACTIVE')
                        }
                        else {
                            this.negotiationsStatuses.splice(index, 1, 'INACTIVE')
                        }
                    })

                    if (this.negotiationsStatuses.indexOf('ACTIVE') == -1){
                        clearInterval(this.countdownFunction)
                    }
                }, 1000)
            }
        }
    },
    watch: {
        performCountdown(){}
    },
    methods: {
        ...mapMutations('negotiation', ['SELECT_TAB']),
        ...mapActions('negotiation', ['selectNegotiation', 'deselectNegotiation', 'selectFuelGroup', 'getNegotiations']),
        ...mapActions('notifications', ['updateNotification']),
        getSellersStatus: function(counterOffers, index){
            if (counterOffers.length > 0){
                counterOffers.forEach(counterOffer => {
                    if (counterOffer.seller.online){
                        return this.isAnySellerOnline[index] = true
                    }
                });
            }
        },
        showNegotiationDetails: function(negotiation){
            this.selectNegotiation(negotiation._id)
            this.SELECT_TAB(0)
            
            /* Remove red dot notification for this negotiation, except if it has counter offer ID as part of its metadata */
            let currentRelevantNotification = this.notificationList.find(notification => notification.type_id === 'NEGOTIATION' && notification.group_id === negotiation._id && !notification.meta && notification.viewed === null)

            if(currentRelevantNotification){
                this.updateNotification(negotiation._id)
            }
        }
    },
    beforeDestroy(){
        clearInterval(this.countdownFunction)
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/_conversations.scss";
</style>    